import * as React from 'react';
import { useAuth } from '@clerk/clerk-react';
import { Outlet, useNavigate } from 'react-router-dom';
import { SidebarProvider } from '@/components/ui/sidebar';
import { AppSidebar } from './NavigationBar/AppSidebar';
import { SecretsPanel } from '@/components/SecretsPanel/SecretsPanel';

export function SignedInLayout() {
    const { userId, isLoaded } = useAuth();
    const navigate = useNavigate();
    const [isSecretsPanelOpen, setIsSecretsPanelOpen] = React.useState(false);

    React.useEffect(() => {
        if (isLoaded && !userId) {
            navigate('/login');
        }
    }, [isLoaded]);

    if (!isLoaded) return <p>Loading...</p>;

    return (
        <SidebarProvider defaultOpen={false}>
            <AppSidebar onSecretsClick={() => setIsSecretsPanelOpen(prev => !prev)} />
            <div className="flex-1 flex flex-col min-h-screen w-full relative">
                <Outlet />
                {isSecretsPanelOpen && <SecretsPanel onClose={() => setIsSecretsPanelOpen(false)} />}
            </div>
        </SidebarProvider>
    );
}
